module.exports = __webpack_public_path__ + "static/media/btn_secondaryschool_04_Riskanddanger.3ec8d3fb.png";